import Grid from "@mui/material/Grid"
import Container from "@mui/material/Container"
import { QuickLinks } from "./quickLinks"
import { SocialLinks } from "./socialLinks"
import { Us } from "./us"

export default function Content() {
  return (
    <Container>
      <Grid sx={{ mt: 1, mb: 3 }} container spacing={4}>
        <Grid
          sx={{ display: "flex", justifyContent: "center" }}
          size={{ xs: 12, sm: 4, md: 3 }}
          order="1"
        >
          <QuickLinks />
        </Grid>
        <Grid
          sx={{ display: "flex", justifyContent: "center" }}
          size={{ xs: 12, sm: 4, md: 6 }}
          order={{ xs: 3, sm: 2 }}
        >
          <Us />
        </Grid>
        <Grid
          sx={{ display: "flex", justifyContent: "center" }}
          size={{ xs: 12, sm: 4, md: 3 }}
          order={{ xs: 2, sm: 3 }}
        >
          <SocialLinks />
        </Grid>
      </Grid>
    </Container>
  )
}
